import { apiFetch } from "../utils/apiFetch";
import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";

const SendInvite = ({ setSendInvitePopUp, workspace }) => {
  const [inputValue, setInputValue] = useState("");
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(false);

  const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleEnter = (e) => {
    if (e.key !== "Enter") return;
    if (inputValue.trim() === "") return;
    if (!isEmail(inputValue)) return;
    setEmails((prev) => {
      if (prev.find((email) => email === inputValue)) return prev;
      return [...prev, inputValue];
    });
    setInputValue("");
  };

  const sendInvitations = async () => {
    try {
      const res = await apiFetch(
        `${process.env.API_URL}/api/invite/${workspace._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",

          },
          body: JSON.stringify({ emails }),
        },
      );

      const data = await res.json();

      if (data.failed.length > 0) {
        alert(`Failed to send to: ${data.failed.join(", ")}`);
      } else {
        alert(`Invites sent successfully!`);
      }
    } catch (err) {
      alert(err.message);
    }
    setLoading(false);
  };
  return (
    <div
      className="fixed inset-0 bg-black/20 flex justify-center items-center z-50"
      onClick={(e) => {
        setSendInvitePopUp(false);
        e.stopPropagation();
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white text-gray-900 p-6 rounded-lg w-[90dvw] md:w-[40dvw]"
      >
        <div className="space-y-3">
          <div>
            <h4 className="font-medium text-gray-900 mb-1">
              Invite by email
            </h4>
            <p className="text-sm text-gray-600">
              Send an invitation link to someone's email address
            </p>
          </div>
          <div className="flex gap-2">
            <div className="flex-1">
              <input
                className="text-gray-900 placeholder:text-gray-500 flex h-9 w-full min-w-0 rounded-md border border-gray-300 px-3 py-1 text-base bg-gray-100 outline-none disabled:opacity-50 focus-visible:ring-2 focus-visible:ring-orange-600"
                placeholder="Enter an email and hit enter to select"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleEnter}
                type="text"
              />
            </div>
          </div>
        </div>

        <div className="flex gap-1 flex-wrap mt-3 mb-3">
          {emails.map((email) => {
            return (
              <div
                key={email}
                className="flex gap-1 rounded-lg border-2 border-blue-900 bg-blue-300 items-center px-2 text-sm"
              >
                <div className="flex items-center">{email}</div>
                <div
                  onClick={() => {
                    setEmails((prev) => prev.filter((p) => p !== email));
                  }}
                >
                  <RxCross2 />
                </div>
              </div>
            );
          })}
        </div>
        <div className="">
          <button
            onClick={() => {
              setLoading(true);
              sendInvitations();
            }}
            disabled={emails.length === 0}
            className={`${emails.length === 0 ? "opacity-50 cursor-not-allowed" : ""} bg-blue-600 md:bg-black  p-2 rounded-lg w-full text-white hover:bg-black/90`}
          >
            {loading && (
              <svg
                className="mr-3 size-5 animate-spin"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  className="opacity-25"
                />
                <path
                  d="M22 12a10 10 0 0 1-10 10"
                  stroke="currentColor"
                  strokeWidth="4"
                  className="opacity-75"
                />
              </svg>
            )}
            Invite
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendInvite;
